import { useStore } from 'modules/Stores';

const useCustomModalOpen = () => {
  const { modalsConfig } = useStore('AppStore');
  const modalConfigValue = Object.values(modalsConfig);
  const anyModalOpen = modalConfigValue.some(modal => modal === true);
  return anyModalOpen;
};

export default useCustomModalOpen;
